"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _AvatarModule = _interopRequireDefault(require("./Avatar.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Avatar = function Avatar(props) {
  var alt = props.alt,
      classes = props.classes,
      classNameProp = props.className,
      childrenProp = props.children,
      childrenClassNameProp = props.childrenClassName,
      ComponentProp = props.component,
      imgProps = props.imgProps,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      other = _objectWithoutProperties(props, ["alt", "classes", "className", "children", "childrenClassName", "component", "imgProps", "sizes", "src", "srcSet"]);

  var className = (0, _clsx["default"])('avatar', {
    'avatar--colorDefault': childrenProp && !src && !srcSet
  }, classNameProp);
  var children = null;

  if (childrenProp) {
    if (childrenClassNameProp && typeof childrenProp !== 'string' && /*#__PURE__*/_react["default"].isValidElement(childrenProp)) {
      var childrenClassName = (0, _clsx["default"])(childrenClassNameProp, childrenProp.props.className);
      children = /*#__PURE__*/_react["default"].cloneElement(childrenProp, {
        className: childrenClassName
      });
    } else {
      children = childrenProp;
    }
  } else if (src || srcSet) {
    children = /*#__PURE__*/_react["default"].createElement("img", _extends({
      alt: alt,
      className: "avatar--img",
      sizes: sizes,
      src: src,
      srcSet: srcSet
    }, imgProps));
  }

  return /*#__PURE__*/_react["default"].createElement(ComponentProp, _extends({
    className: className
  }, other), children);
};

Avatar.defaultProps = {
  component: 'div'
};
Avatar.propTypes = {
  /**
     * Used in combination with `src` or `srcSet` to
     * provide an alt attribute for the rendered `img` element.
     */
  alt: _propTypes["default"].string,

  /**
     * Used to render icon or text elements inside the Avatar.
     * `src` and `alt` props will not be used and no `img` will
     * be rendered by default.
     *
     * This can be an element, or just a string.
     */
  children: _propTypes["default"].node,

  /**
     * @ignore
     * The className of the child element.
     * Used by Chip and ListItemIcon to style the Avatar icon.
     */
  childrenClassName: _propTypes["default"].string,

  /**
     * Useful to extend the style applied to components.
     */
  className: _propTypes["default"].string,

  /**
     * @ignore
     */
  classes: _propTypes["default"].object,

  /**
     * The component used for the root node.
     * Either a string to use a DOM element or a component.
     */
  component: _propTypes["default"].node,

  /**
     * Properties applied to the `img` element when the component
     * is used to display an image.
     */
  imgProps: _propTypes["default"].object,

  /**
     * The `sizes` attribute for the `img` element.
     */
  sizes: _propTypes["default"].string,

  /**
     * The `src` attribute for the `img` element.
     */
  src: _propTypes["default"].string,

  /**
     * The `srcSet` attribute for the `img` element.
     */
  srcSet: _propTypes["default"].string
};
var _default = Avatar;
exports["default"] = _default;